import { j as e } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as l } from "react";
import m from "../../../SegmentedControl/SegmentedControl.js";
const n = ({
  segmentControls: t,
  onItemClick: o,
  selectedControlItemIndex: r
}) => /* @__PURE__ */ e.jsx("div", { className: "bg-color-bg-neutral-lightest-default p-075", children: /* @__PURE__ */ e.jsx(
  m,
  {
    segmentControls: t,
    onControlItemClick: o,
    defaultSelectedControlItem: r,
    borderless: !0,
    compact: !0
  }
) }), c = l(n);
export {
  c as default
};
//# sourceMappingURL=TableSegmentedControl.js.map
